import React, {useMemo, useState} from "react";
import Button from "../baseComponents/gui/button/Button";
import Carousel from "../baseComponents/gui/carousel/Carousel";
import {settings} from "../../constants/carousel-settings";
import classNames from "classnames";
import ProjectSlide from "./ProjectSlide";
import styles from "./Project.module.scss";

const ProjectList = React.forwardRef(
  function ProjectList({season, slide, setSlide}, ref) {

    const [progress, setProgress] = useState(0)
    const itemData = useMemo(()=>{
      season.forEach((item)=>{
        item.slide = slide;
        item.setSlide = setSlide;
      })
      return season;
    },[season,slide])


    return (
      <div className={classNames(styles.project__list, {
        [styles.project__list_left]: progress === 1,
        [styles.project__list_right]: progress !== 1,
      })}>
        <Carousel settings={{...settings.series, onSlideChange: (swiper)=> setProgress(swiper.progress)}}
                  itemsData={itemData} selectedSlide={slide} item={ProjectSlide}/>
        {/*<div className={'project__nav project__nav_prev'}>*/}
        {/*  <Button className={'button_nav'} icon={'projects/arrow'}/>*/}
        {/*</div>*/}
        {/*<div className={'project__nav project__nav_next'}>*/}
        {/*  <Button className={'button_nav'} icon={'projects/arrow'}/>*/}
        {/*</div>*/}
      </div>

    );
  });
export default ProjectList;
ProjectList.propTypes = {};

